import { render, staticRenderFns } from "./cityTrigger.vue?vue&type=template&id=498422e8&scoped=true&"
import script from "./cityTrigger.vue?vue&type=script&lang=js&"
export * from "./cityTrigger.vue?vue&type=script&lang=js&"
import style0 from "./cityTrigger.vue?vue&type=style&index=0&id=498422e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498422e8",
  null
  
)

export default component.exports